import React from 'react';

const MarkdownImage: React.FunctionComponent<{}> = (props: any) => (
  <img style={{ maxWidth: '100%' }} src={props.src} alt={props.title} />
);

export default MarkdownImage;
